function BookNavigationTabItems() {
  return [];
}

export default BookNavigationTabItems;
